import React from 'react';
import { Icon } from '@fuxi/eevee-icon';

import cx from './index.module.scss';

interface Props {
  className?: string;
}

const EmptyBox: React.FC<Props> = props => {
  const { className } = props;

  return (
    <div className={cx('empty-wrapper', className)}>
      <Icon name="empty-data" className={cx('empty-icon')} />
      <div>当前无服务记录</div>
    </div>
  );
};

export default EmptyBox;
